import type { ButtonHTMLAttributes } from 'react'

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked: boolean
  onChange: (next: boolean) => void
}

export const Switch = ({ checked, disabled, onChange, className = '', ...rest }: SwitchProps) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()
    if (disabled) return
    onChange(!checked)
  }

  return (
    <button
      type='button'
      role='switch'
      aria-checked={checked}
      disabled={disabled}
      className={`mp-agent-switch ${checked ? 'on' : 'off'} ${className}`.trim()}
      onClick={handleClick}
      {...rest}
    >
      <span className='mp-agent-switch-thumb' />
    </button>
  )
}

export default Switch
